"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_QUERIES = exports.UNORDERED_ITEM_POSITION = exports.VARY_HEADER = exports.CACHE_CONTROL_HEADER = exports.PUBLIC_SUBMISSIONS_PAGE_SIZE = exports.QS_STRINGIFY_OPTIONS = void 0;
exports.QS_STRINGIFY_OPTIONS = { arrayFormat: 'comma', skipNulls: true };
exports.PUBLIC_SUBMISSIONS_PAGE_SIZE = 20; // 20
var DAY = 60 * 60 * 24;
var MINUTE = 60 * 1;
var CACHE_VALUE = process.env.ENV === 'production' ? 1 * DAY : 10 * MINUTE;
exports.CACHE_CONTROL_HEADER = "public, max-age=".concat(CACHE_VALUE, ", s-maxage=").concat(CACHE_VALUE);
exports.VARY_HEADER = 'origin, accept-encoding';
exports.UNORDERED_ITEM_POSITION = 999999999;
exports.ALLOWED_QUERIES = [
    'query',
    'page',
    'limit',
    'offset',
    'filters',
    'sCh',
    'pId',
    'partner',
    'referrer',
    'tagName',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'main_article',
    'click_id',
    'fbclid',
];
//# sourceMappingURL=other.js.map